import { useContext } from 'react'
import { SessionContext, useExplorerConfig } from './providers'
import { SImage, SText, SView, SViewProps } from './scaled'

interface Props extends SViewProps {}

export default function CustomerLogo(props: Props) {
  const { templateDocs, workspace, facility } = useExplorerConfig()
  const { status, getLanguageValue } = useContext(SessionContext)
  if (facility && status === 'screensaver') return null

  const { logo } = templateDocs?.template || {}
  if (!logo) return null

  const url = templateDocs?.media.find(m => m.id === logo.media)?.url

  return (
    <SView position="absolute" zIndex={2} left={40} top={40} gap={10} {...props}>
      {logo.text && <SText fontSize={17}>{getLanguageValue(logo.text)}</SText>}
      {url ? (
        <SView gap={27} alignItems="flex-start">
          <SImage h={40} src={url} />
          {!workspace?.branding?.hideBranding && (
            <SImage h={25} src="/common/by-momentify-light.svg" />
          )}
        </SView>
      ) : (
        <SImage h={40} src="/common/momentify-logo-light.svg" />
      )}
    </SView>
  )
}
